<template>
	<v-container fluid>
		<v-tabs
			v-model="tab"
			@change="
				() => {
					user = null;
					userPerson = null;
				}
			"
			background-color="transparent"
			color="primary"
			grow
		>
			<v-tab>
				Administradores
			</v-tab>
			<v-tab>
				personas
			</v-tab>
			<v-tab>
				todos
			</v-tab>
		</v-tabs>

		<v-tabs-items v-model="tab">
			<!-- administradores -->
			<v-tab-item>
				<v-row v-if="!userProfile">
					<v-col cols="12">
						<v-skeleton-loader type="card"></v-skeleton-loader>
					</v-col>
				</v-row>
				<v-row class="mt-4">
					<v-col cols="12" sm="6" md="4" offset-sm="3" offset-md="4">
						<AutocompleteUsers
							v-if="tab == 0"
							role="admin"
							:set-user="setUser"
							:cleaning="cleaning"
						/>
					</v-col>
				</v-row>
				<v-row v-if="Boolean(user)">
					<v-col cols="12"> </v-col>
					<v-col cols="3" class="text-center">
						<v-menu v-model="menu" :close-on-content-click="false" max-width="290">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									clearable
									dense
									outlined
									filled
									label="Seleccione un mes para ver las notificaciones enviadas"
									readonly
									v-bind="attrs"
									v-on="on"
									@click:clear="month = null"
									hide-details
									:value="dateFormatted()"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="month"
								@change="menu = false"
								no-title
								type="month"
								locale="es"
							></v-date-picker>
						</v-menu>
					</v-col>
					<v-col cols="10" sm="3" @click="selectedCard(0)">
						<AutocompletePersons
							:id="user._id"
							:selected="selected"
							:set-person="setItemPerson"
						/>
					</v-col>
					<v-col cols="10" sm="3" @click="selectedCard(1)">
						<AutocompletePlaces
							:id="user._id"
							:selected="selected"
							:set-place="setItemPlace"
						/>
					</v-col>
					<v-col cols="10" sm="3" @click="selectedCard(2)">
						<AutocompleteInvoice
							:id="user._id"
							:selected="selected"
							:set-invoice="setItemInvoice"
						/>
					</v-col>
					<v-col>
						<div
							class="text-center body-1 font-weight-bold primary--text"
							style="height: 30px"
						>
							Notificaciones enviadas en {{ dateFormatted(true) }}:
							{{ monthNotifications }}
						</div>
						<person-card
							v-show="selected === 0 && itemPerson.firstName"
							:id="user._id"
							:item="itemPerson"
							:cleaning="cleaning"
						/>
						<place-card
							v-show="selected === 1 && itemPlace.name"
							:id="user._id"
							:cleaning="cleaning"
							:item="itemPlace"
						/>
						<invoice-card
							v-show="selected === 2 && itemInvoice.month"
							:id="user._id"
							:item="itemInvoice"
							:cleaning="cleaning"
						/>
					</v-col>
					<v-col cols="12">
						<table-ot-from-audit :user="user" />
					</v-col>
				</v-row>
			</v-tab-item>
			<!-- personas -->
			<v-tab-item>
				<v-row class="mt-4">
					<v-col cols="12" sm="6" md="4" offset-sm="3" offset-md="4">
						<AutocompleteUsers
							v-if="tab == 1"
							role="person"
							:set-user="setUserPerson"
							:cleaning="cleaning"
						/>
					</v-col>
					<v-col v-if="userPerson" cols="12"> </v-col>
				</v-row>
			</v-tab-item>
			<!-- todos -->
			<v-tab-item>
				<v-row class="mt-10">
					<v-col cols="12">
						<table-all-users />
					</v-col>
				</v-row>
			</v-tab-item>
		</v-tabs-items>
	</v-container>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'Dashboard',
	components: {
		AutocompleteInvoice: () => import('@/components/dashboard/AutocompleteInvoice'),
		AutocompletePersons: () => import('@/components/dashboard/AutocompletePersons'),
		AutocompletePlaces: () => import('@/components/dashboard/AutocompletePlaces'),
		AutocompleteUsers: () => import('@/components/dashboard/AutocompleteUsers'),

		InvoiceCard: () => import('@/components/dashboard/InvoiceCard'),
		PersonCard: () => import('@/components/dashboard/PersonCard'),
		PlaceCard: () => import('@/components/dashboard/PlaceCard'),
		TableOtFromAudit: () => import('@/components/dashboard/TableOtFromAudit.vue'),
		TableAllUsers: () => import('@/components/dashboard/TableAllUsers.vue'),
	},
	data() {
		return {
			tab: 0,
			selected: null,
			user: null,
			userPerson: null,
			itemPerson: {},
			itemPlace: {},
			itemInvoice: {},
			menu: false,
			month: moment()
				.date(1)
				.format('YYYY-MM'),
		};
	},
	computed: {
		...mapGetters({
			users: 'User/users',
		}),
		monthNotifications() {
			const monthNotifications = this.user.notifications.filter(notification => {
				let today;
				if (this.month) {
					today = moment(this.month);
				} else today = moment();
				if (today.isSame(notification.date, 'month')) return notification;
			});
			return monthNotifications.length;
		},
	},
	mounted() {
		this.fetchUsers();
	},
	methods: {
		dateFormatted(onlyMonth = false) {
			if (onlyMonth) return this.month ? moment(this.month).format('MMMM') : '';
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		setUser(value) {
			this.user = value;
		},
		setUserPerson(value) {
			this.userPerson = value;
		},
		setItemPerson(value) {
			if (value) {
				this.itemPerson = value;
			}
		},
		setItemPlace(value) {
			if (value) {
				this.itemPlace = value;
			}
		},
		setItemInvoice(value) {
			if (value) {
				this.itemInvoice = value;
			}
		},
		selectedCard(value) {
			if (value === 0) {
				this.selected = 0;
				this.itemInvoice = { status: true };
				this.itemPlace = { status: true };
			} else if (value === 1) {
				this.selected = 1;
				this.itemInvoice = { status: true };
				this.itemPerson = {};
			} else if (value === 2) {
				this.selected = 2;
				this.itemPerson = {};
				this.itemPlace = { status: true };
			}
		},
		cleaning() {
			this.itemPerson = { status: true };
			this.itemPlace = { status: true };
			this.itemInvoice = { status: true };
		},
		...mapActions({
			fetchUsers: 'User/fetchUsers',
		}),
	},
};
</script>

<style media="screen">
.minwidthtabla {
	min-width: 250px !important;
}
</style>
